import React from "react";
import { H5, LI } from "../../../../AbstractElements";
import FeatherIconCom from "../../../../CommonElements/FeatherIcon";

const UserPlus = () => {
  return (
    <LI className="border-0">
      <div className="user-icon primary">
        <div className="user-box">
          <FeatherIconCom iconName="UserPlus" className="font-primary" />
        </div>
      </div>
      <div>
        <H5 className="mb-1">178,098</H5>
        <span className="font-primary d-flex align-items-center">
          <i className="icon-arrow-up icon-rotate me-1"> </i>
          <span className="f-w-500">+30.89</span>
        </span>
      </div>
    </LI>
  );
};

export default UserPlus;
